import { logDate } from './homeNav.js'
import { isGymWear } from './wearOccasions.js'

export function sessionStartedAt(log) {
  const initial = (log.applications || []).filter(app => !app.is_reapplication)
    .sort((a, b) => new Date(a.applied_at) - new Date(b.applied_at))[0]
  return initial?.applied_at || log.created_at || `${logDate(log)}T00:00:00`
}

export function sessionsForDay(logs, day) {
  return logs.filter(log => logDate(log) === day).slice().sort((a, b) =>
    (new Date(sessionStartedAt(b)) - new Date(sessionStartedAt(a))) || String(b.id).localeCompare(String(a.id)))
}

export function homeReferenceTiles(tiles, logs, day, currentPrimaryId = null) {
  const today = logs.filter(log => logDate(log) === day)
  const sotd = today.find(log => (log.wear_label || 'sotd') === 'sotd' && !isGymWear(log))
  return tiles.filter(tile => {
    if (!tile?.fragrance) return false
    const f = tile.fragrance
    const ownedIds = [f.id, ...(f.sizes || []).map(size => size.id)]
    return !((sotd && ownedIds.includes(sotd.fragrance_id)) || (currentPrimaryId && ownedIds.includes(currentPrimaryId)))
  }).slice(0, 6)
}

// A single initial-application contract accepts legacy callers and future
// recipe prefills. Explicit application values take precedence over defaults.
export function prepareWearSession(entry, application) {
  const { sprays, ...session } = entry
  const initial = { ...application }
  if (initial.sprays === undefined) initial.sprays = sprays ?? null
  if (initial.sprays !== null && initial.sprays !== '') {
    initial.sprays = Number(initial.sprays)
    if (!Number.isInteger(initial.sprays) || initial.sprays < 1 || initial.sprays > 30) {
      throw new Error('Enter between 1 and 30 sprays for this application.')
    }
  } else initial.sprays = null
  return { session, application: initial }
}
